import type { BlockPartnersLocation } from 'types/block-partners-location';
import React from 'react';
import Image from 'next/image';
import { Wrap, Paragraph } from '@leafwell/components';
import LocationBusinessJson from 'components/structured-data/location-business';

const PartnersLocation: React.FC<BlockPartnersLocation> = ({
  title,
  partners,
  partnersMap,
}) => {
  return (
    <>
      <Wrap className="gap-y-4">
        <header className="md:grid grid-cols-2 pb-10 border-b border-solid border-gray-200">
          <Paragraph className="col-span-1 text-3xl sm:text-5xl lg:leading-tight lg:my-reset">
            {title}
          </Paragraph>
        </header>
        {partners.length ? (
          <ul className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-y-10 gap-x-12">
            {partners.map((partner, index) => {
              const { formattedAddress, internationalPhoneNumber } = partner;

              return (
                <li
                  key={`partner-${index}`}
                  className="col-span-1 flex flex-col gap-y-2"
                >
                  <p className="text-sm lg:text-base flex items-center">
                    <Image
                      className="inline mr-1.5"
                      src="/location.svg"
                      alt=""
                      width={16}
                      height={16}
                    />
                    {formattedAddress}
                  </p>
                  <p className="text-sm lg:text-base flex items-center">
                    <Image
                      className="inline mr-1.5"
                      src="/mobile.svg"
                      alt=""
                      width={16}
                      height={16}
                    />
                    {internationalPhoneNumber}
                  </p>
                </li>
              );
            })}
          </ul>
        ) : null}
      </Wrap>
      {partnersMap?.src ? (
        <section className="py-14 px-8 bg-gray-100">
          <Image
            src={partnersMap.src}
            alt={partnersMap.alt}
            width={partnersMap.width}
            height={partnersMap.height}
            sizes="(max-width: 1023px) 100vw, 50vw"
            className="w-full max-w-xl mx-auto"
          />
        </section>
      ) : null}
      <LocationBusinessJson partners={partners} />
    </>
  );
};

export default PartnersLocation;
